import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
  Stack,
} from "@mui/material";
import { createContext, useContext, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";

const CustomDialogContext = createContext(undefined);

const CustomDialogWrapper = ({ children, variant, onClose, ...props }) => {
  let res;

  if (variant === "drawer") {
    res = (
      <Drawer
        {...props}
        anchor="right"
        variant="temporary"
        slotProps={{
          paper: {
            sx: { width: { sm: 600, xs: "100vw" }, flexShrink: { sm: 0 } },
          },
        }}
        ModalProps={{ onClose: props.onClose }}
      >
        {children}
      </Drawer>
    );
  } else if (variant === "component") {
    res = <>{children}</>;
  } else {
    res = (
      <Dialog
        closeAfterTransition={false}
        width="md"
        maxWidth="md"
        fullWidth
        {...props}
      >
        {children}
      </Dialog>
    );
  }

  return (
    <CustomDialogContext.Provider value={{ variant, onClose }}>
      {res}
    </CustomDialogContext.Provider>
  );
};

export const CustomDialogTitle = ({ children, ...props }) => {
  const { onClose } = {
    ...useContext(CustomDialogContext),
    ...props,
  };
  const sx = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: (theme) => theme.zIndex.drawer + 1,
    boxShadow: (theme) => theme.shadows[4],
  };

  return (
    <DialogTitle
      {...props}
      sx={{ ...props.sx, ...sx }}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"stretch"}
    >
      {onClose && (
        <IconButton
          edge="start"
          color="inherit"
          onClick={onClose}
          sx={{ flexGrow: 0, flexShrink: 0 }}
        >
          <CloseIcon />
        </IconButton>
      )}
      {children}
    </DialogTitle>
  );
};

export const CustomDialogContent = ({ children, ...props }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    contentRef.current?.focus();
  }, []);

  return (
    <DialogContent dividers ref={contentRef} {...props}>
      {children}
    </DialogContent>
  );
};

export const CustomDialogActions = ({ children, ...props }) => {
  const sx = {
    position: "sticky",
    bottom: 0,
    backgroundColor: "white",
    zIndex: (theme) => theme.zIndex.drawer + 1,
    boxShadow: (theme) => theme.shadows[4],
  };

  return (
    <DialogActions {...props} sx={{ ...props.sx, ...sx }}>
      {children}
    </DialogActions>
  );
};

const CustomDialog = ({ title, content, actions, children, ...props }) => {
  let res = <CustomDialogWrapper {...props}>{children}</CustomDialogWrapper>;
  if (title) res = <CustomDialogTitle {...props}>{children}</CustomDialogTitle>;
  if (content)
    res = <CustomDialogContent {...props}>{children}</CustomDialogContent>;
  if (actions)
    res = <CustomDialogActions {...props}>{children}</CustomDialogActions>;
  return res;
};

export default CustomDialog;
